import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _EmployeeBonus, _EmployeeIncapacity, _EmployeeNovelty } from '../../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const LiquidateMonthConstantsEditor = ({ idSelector, onChange, label }: Props) => {

    const incapacity = useDataBean(_EmployeeIncapacity)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        setID(idSelector);
    }, [])

    useEffect(()=>{
        getLista();
    },[])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(e);
        ////console.log(id)
    }

    const getLista = () => {
        incapacity.instance.getLiquidateMonthConstants(null).then(
            (resp) => {
                setLista(resp);
            }
        );
    }


    return (
        <>
            <label>{label ?? "Mes a Aplicar"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null} >...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}